import React from 'react';

import { LoadableAfterPaint } from '@confluence/loadable';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';

const SpaceManagementPageRouteComponent = LoadableAfterPaint({
	loader: async () =>
		import(
			/* webpackChunkName: "loadable-SpaceManagementPageRouteComponent" */ './SpaceManagementPageRouteComponent.tsx'
		),
});

export const SpaceManagementPageRoute = () => <SpaceManagementPageRouteComponent />;

SpaceManagementPageRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: {
			name: 'spaceManagementScreen',
		},
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
